import moment from "moment";
import React, { useState } from "react";
import { decryptData, maskSSN } from "../../../utils/helper";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { useNavigate } from "react-router";
import AddReceipt from "./AddReceipt";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../../utils/Tostify";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import { updateApplication, updateApplicationReceipt } from "../../../api/Applications";
import { platformLayout } from "../../../utils/constants";
import { stageStatusOption } from "../Constant";

const ReceiptView = ({application,getApplication,patientDetails}) => {
  const navigate = useNavigate();
  const [showReceiptModal, setShowAddReceiptModal] = useState(false);
  const [receiptData, setReceiptData] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  let role = localStorage.getItem("userRole");
  const isPatient = role === "Patient";
  const [isLoading, setIsLoading] = useState(false);
  const { getConfirmation } = useConfirmDialog();
  const [docEditingIndex, setDocEditingIndex] = useState(null);
  const [docTitle, setDocTitle] = useState('');

  const toggleModal = ()=>{
    setShowAddReceiptModal(false);
    setReceiptData({});
   };

   const toggleDropdown = (id) => {
    setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
  };

  const handleDeleteClick = async (receiptId) => {
    let res;
    try {
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: "Are you sure you want to delete the receipt?"
      });
      if (confirmed) {
        const updatedApplicationReceipt = application.receipts.filter((form)=> form?._id != receiptId);
        const values = {receipts : updatedApplicationReceipt};
        setIsLoading(true);
        res = await updateApplication({values, dispatch, token, applicationId : application?._id});
        if (res?.status === "SUCCESS") {
            setDocEditingIndex(null);
            await getApplication();
            setIsLoading(false);
            success(res?.message);
        }else {
            setIsLoading(false);
            failed(res?.message);
        }
      }
    } catch (error) {
      setIsLoading(false);
      failed(error?.message || "An error occurred");
    }
  };

  const handleUpload = async (receiptId) => {
    // Create a file input dynamically
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".pdf,.doc,.docx"; // Accept specific file types if needed
    let base64pdfForm= "";
    let res;
    // Handle the file selection
    fileInput.onchange = async (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        try {
          base64pdfForm = await handleFileUpload(selectedFile);
          const fileExtension = selectedFile?.type?.split("/")[1];

          const filePayload = {
            base64String: base64pdfForm,
            extension: fileExtension,
            name: selectedFile?.name,
            userId: application?._id
          };
          // Call the API to upload or update the document
          const res = await updateApplicationReceipt({
            values: {receiptFile:filePayload},
            dispatch,
            token,
            applicationId: application?._id,
            receiptId: receiptId
          });

          if (res?.status === "SUCCESS") {
            success(res?.message); // Show success message
            getApplication(); // Refresh the data if needed
          } else {
            failed(res?.message); // Show error message
          }
        } catch (error) {
          console.error("File upload error:", error);
          failed("File upload failed.");
        }
      }
    };
    fileInput.click();
  };

  const handleDownload = (url) =>{
    window.open(url, "_blank");
  };


  const handleEditClick = (index, currentTitle) => {
    setDocEditingIndex(index);
    setDocTitle(currentTitle);
  };

  const handleDocTitleChange = (e) => {
    setDocTitle(e.target.value);
  };

  const handleDocTitleSaveClick = async(index, receiptId) => {
    let res;
    try {
      const updatedApplicationDoc = application.receipts.map((doc)=> {
        if(doc._id === receiptId){
          return {
            ...doc,
            title : docTitle
          };
        }
        return doc;
      });
      const values = {receipts : updatedApplicationDoc};
      setIsLoading(true);
      res = await updateApplication({values, dispatch, token, applicationId : application?._id});
      if (res?.status === "SUCCESS") {
          setDocEditingIndex(null);
          await getApplication();
          setIsLoading(false);
          success(res?.message);
      }else {
          setIsLoading(false);
          failed(res?.message);
      }
  } catch (error) {
      failed(res?.message);
      setIsLoading(false);
  }
  };

  return (
    <div className="data_patient">
      <div className="application_details_block mt-3 mb-3">
      <Row>
        <h3 className="title_name mt-0">Application Overview</h3>
        <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>
      </Row>
        {role !== platformLayout?.Patient && <Row className="mt-3 align-items-center">
                        <h3 className="title_name mt-1">Primary Applicant</h3>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Name</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(application?.patientData?.name[0].text)}{" "}
                                <button
                                  className="add_notes"
                                  onClick={() =>
                                    navigate("/clinic/patient-profile", {
                                      state: { patientData: application?.patientData?._id, isEditMode: true}
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-3 text-end"><p>Email ID</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(
                                  application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                    ?.value || "-"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Gender</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>DOB</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>State</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                              {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Row>}
      </div>
      <h6 className="form_name list_blk">Receipts: </h6>
      <div className="table_space">
        <div className="table-responsive">
          <table>
            <th></th>
            <th>Name</th>
            <th>Updated</th>
            <th>Actions</th>
            {application?.receipts?.length > 0 ? (
              application?.receipts?.map((receipt, index) => (
                <tbody key={receipt?._id}>
                  <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                    <td>{index + 1}</td>
                    <td>
                      {docEditingIndex === index ? (
                        <input
                          type="text"
                          value={docTitle}
                          onChange={handleDocTitleChange}
                          onBlur={() => handleDocTitleSaveClick(index, receipt._id)}
                          autoFocus
                        />
                      ) : (
                        receipt?.title
                      )}
                      </td>
                      <td>{moment(receipt.uploadDate).format("MM-DD-YYYY")}</td>
                      <td className="p-0 upload_blk">
                        <Dropdown isOpen={dropdownOpen.includes(receipt?._id)} toggle={() => toggleDropdown(receipt._id)}>
                          <DropdownToggle caret size="xl" className="column_blk">
                            <div className="for_details">
                              <i className="fa fa-ellipsis-v"></i>
                            </div>
                          </DropdownToggle>
                          <DropdownMenu>
                            {!isPatient && (
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleEditClick(index, receipt?.title)}>
                              <div className="add_hosp">Edit</div>
                            </DropdownItem>
                            )}
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleDownload(receipt?.receiptFile?.signedUrl)}>
                              <div className="add_hosp">Download</div>
                            </DropdownItem>
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleUpload(receipt?._id)}>
                              <div className="add_hosp">Upload</div>
                            </DropdownItem>
                            {!isPatient && (
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleDeleteClick(receipt?._id)}>
                              <div className="add_hosp">Delete</div>
                            </DropdownItem>
                            )}
                          </DropdownMenu>
                        </Dropdown>
                      </td>
                    </tr>
                  </tbody>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>
                    <p className="text-center">No Data Found</p>
                  </td>
                </tr>
              )}
          </table>
        </div>
      </div>
      {role !== platformLayout?.Patient &&  <div className="d-flex justify-content-center mt-3">
        <button className="add_document" onClick={()=> setShowAddReceiptModal(true)}>Add Receipt</button>
      </div>}
      <AddReceipt
        isOpen={showReceiptModal}
        application={application}
        getApplication={getApplication}
        toggle={toggleModal}
        receiptData={receiptData}
        patientDetails= {patientDetails}
      />
    </div>
  );
};

export default ReceiptView;
